/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitCostLogDto } from '../../models/unit-cost-log-dto';

export interface GetUnitCostLog$Params {
  id: string;
}

export function getUnitCostLog(http: HttpClient, rootUrl: string, params: GetUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDto>> {
  const rb = new RequestBuilder(rootUrl, getUnitCostLog.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostLogDto>;
    })
  );
}

getUnitCostLog.PATH = '/v0/unitCostLogs/{id}';
